<div class="ticket-emails-container">
  <div *ngIf="loading" class="loading-spinner">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
    <p>Loading email conversation...</p>
  </div>

  <div *ngIf="!loading && emails.length === 0" class="no-emails">
    <p>No email conversation found.</p>
  </div>

  <div *ngIf="!loading && emails.length > 0" class="email-list">
    <div *ngFor="let email of emails; let last = last" class="email-item">
      <div class="email-header">
        <div class="email-separator"></div>
        <div class="email-meta">
          <div class="email-from">
            <strong>From:</strong> {{ getFromDisplay(email) }}
          </div>
          <div class="email-subject">
            <strong>Subject:</strong> {{ email.subject }}
          </div>
        </div>
        <div class="email-separator"></div>
      </div>
      
      <div class="email-body">
        <div [innerHTML]="email.description | cleanEmailImgHtml"></div>
      </div>
      <div *ngIf="!last" class="email-divider">
        <div class="email-separator"></div>
      </div>
    </div>
  </div>
</div>